export const BOOL = "Bool";
export const COUNTER = "Counter";
export const NUMBER = "Number";
export const TIME = "Time";
export const TIMER = "Timer";

export const NUMBER_MIN = -2147483648;
export const NUMBER_MAX = 2147483647;
export const TIME_MIN = 0;
export const TIME_MAX = 86400000;
